import { NameDto } from '../../Common/Types'

export interface SubscriptionDetailsDto {
  id: string
  name: string | null
  description: string | null
  group: SubscriptionGroupDto
  currency: { id: string; name: string }
  billingPeriod: NameDto
  subscriptionClassificationType: NameDto
  documentId: string | null
  enabled: boolean
  tradingAccountRequired: boolean
  order: number
  tickmillProduct: NameDto
  details: SubscriptionDetailDto[]
  platforms: SubscriptionPlatformDto[]
  isThirdPartyTradingPlatform: boolean
}

interface SubscriptionGroupDto {
  id: string
  name: string | null
  type: NameDto
}

export interface SubscriptionDetailDto {
  id: string
  name: string | null
  description: string | null
  subscriptionId?: string
  detailType: SubscriptionDetailTypeDto
  amount: number
  mappingId: string
  mappingText: string
  bundles: SubscriptionDetailBasicDto[]
}

export enum SubscriptionDetailsKey {
  name = 'name',
  description = 'description',
  type = 'detailType.name',
  amount = 'amount',
  mappingId = 'mappingId',
  mappingText = 'mappingText',
}

interface SubscriptionDetailTypeDto {
  id: number
  name: string | null
  shortName: string | null
  description: string | null
}

interface SubscriptionDetailBasicDto {
  id: string
  name: string | null
  description: string | null
  subscriptionId: string
  detailType: SubscriptionDetailTypeDto
  amount: number
}

interface SubscriptionDetailTypeDto {
  id: number
  name: string | null
  shortName: string | null
  description: string | null
}

export interface SubscriptionPlatformDto {
  subscriptionId: string
  platformType: NameDto
  tickmillCompany: NameDto
}

export enum SubscriptionPlatformKey {
  platform = 'platformType.name',
  company = 'tickmillCompany.name',
}
